import { useTranslations } from 'next-intl'

export const MobileNoFAQ = () => {
  const t = useTranslations('faq')

  return (
    <div className="typo-label1 flex h-40 items-center justify-center text-center whitespace-break-spaces text-gray-400">
      {t('search_result.empty.description')}
    </div>
  )
}
